import { BaseWebComponentView } from '../../../framework/BaseWebComponentView';
import { TemplateState } from '../../../types/common/types';
import { TagItem } from '../../tagsManagerGrid/types';
import { GzTagsEnumFilterWebComponent } from '../../ui/gzTagsEnumFilter';
import { ExcludedTagTypes, ExtendedTagEnumListItem } from '../../ui/gzTagsEnumList/types';

export class TagsNetworkFilterView extends BaseWebComponentView {
  public shouldUsePluralOnEmptyStateText: boolean = false;

  public dom: {
    $wrapper: HTMLElement;
    $tagFilterSelector: GzTagsEnumFilterWebComponent;
  };
  getDomElements() {
    this.dom = {
      $wrapper: this.shadow.querySelector('.wrapper'),
      $tagFilterSelector: this.shadow.querySelector('#tag-filter-for-pe'),
    };

    this.getTranslations();
    this.setTranslatedStrings();
  }

  setLoadingState(): void {
    this.resetTemplateState(this.dom.$wrapper);
    this.setTemplateState(this.dom.$wrapper, TemplateState.LOADING);
  }

  removeLoadingState(): void {
    this.resetTemplateState(this.dom.$wrapper);
  }

  getTranslations() {
    this.commonStrings = this.stringsTranslator.getCommonStrings();
  }

  setTranslatedStrings() {
    this.dom.$tagFilterSelector.placeholder = this.dependencies.translateFn('Select at least one option');
    this.dom.$tagFilterSelector.searchPlaceholderString = this.dependencies.translateFn('Search tag');
    this.dom.$tagFilterSelector.confirmActionButtonString = this.commonStrings.apply;
    this.dom.$tagFilterSelector.emptyFilterString = this.shouldUsePluralOnEmptyStateText
      ? this.dependencies.translateFn(
          'No tags found for the selected companies. To create tags, go to the Tags Management page.'
        )
      : this.dependencies.translateFn(
          'No tags found for the selected company. To create tags, go to the Tags Management page.'
        );
    this.dom.$tagFilterSelector.noResultsInDefaultGroup = this.dependencies.translateFn('No tags available.');
    this.dom.$tagFilterSelector.errorMessage = this.dependencies.translateFn('Error loading tags');
    this.dom.$tagFilterSelector.allItemsLabel = this.dependencies.translateFn('All options');
    this.dom.$tagFilterSelector.allAutoTagsLabel = this.dependencies.translateFn('All automatic tags');
    this.dom.$tagFilterSelector.allCustomTagsLabel = this.dependencies.translateFn('All custom tags');
    this.dom.$tagFilterSelector.noSearchResultsString = this.dependencies.translateFn('No tags found.');
  }

  buildSuccessView({
    gzTags,
    selectedItems,
    shouldDisplayOptions = true,
  }: {
    gzTags: Array<TagItem>;
    selectedItems: Array<string>;
    shouldDisplayOptions: boolean;
  }) {
    let emptyStateText = '';

    if (shouldDisplayOptions) {
      emptyStateText = this.shouldUsePluralOnEmptyStateText
        ? this.dependencies.translateFn(
            'No tags found for the selected companies. To create tags, go to the Tags Management page.'
          )
        : this.dependencies.translateFn(
            'No tags found for the selected company. To create tags, go to the Tags Management page.'
          );
    } else {
      emptyStateText = this.shouldUsePluralOnEmptyStateText
        ? this.dependencies.translateFn('Select specific companies to view endpoint tags.')
        : this.dependencies.translateFn('Select a specific company to view endpoint tags.');
    }
    this.dom.$tagFilterSelector.canSelectAll = gzTags.length > 0;
    this.dom.$tagFilterSelector.emptyFilterString = emptyStateText;
    this.dom.$tagFilterSelector.noResultsInDefaultGroup = this.dependencies.translateFn('No tags available.');
    this.dom.$tagFilterSelector.noSearchResultsString = this.dependencies.translateFn('No tags found.');
    this.dom.$tagFilterSelector.filterOptions = gzTags.map(gzTag => {
      const newGzTag = {
        label: gzTag.name,
        value: gzTag._id,
        selected: selectedItems.indexOf(gzTag._id) !== -1,
        additionalData: {
          type: gzTag.type,
        },
      } as ExtendedTagEnumListItem;

      if (
        this.dependencies.isCloud() &&
        this.dependencies.permissions.canHaveChildCompanies &&
        gzTag.type !== ExcludedTagTypes.NO_TAGS_SELECTED
      ) {
        newGzTag.parent = gzTag.company.name;
      }

      return newGzTag;
    });
  }
}
